import Axios from '@/components/api/axios.js'

/**********************************************************************************
 * 事件
 **********************************************************************************/
export default {
	/**
	 * 查询事件
	 * @param {Object} userId 用户id,不传是当前用户
	 * @param {Object} unitId 单位id
	 * @param {Object} typeNos 事件类型不传是全部,参数用逗号隔开
	 * @param {Object} state 事件状态
	 * @param {Object} level 事件等级，不传是默认1,2
	 * @param {Object} deviceid 设备id，支持多个设备id
	 * @param {Object} startTime
	 * @param {Object} endTime
	 * @param {Object} pageIndex
	 * @param {Object} pageLen
	 * @param {Object} linkobject 关联对象，支持模糊查询
	 */
	searchEventListByUser: (userId, unitId, typeNos, state, level, deviceid, startTime, endTime, pageIndex, pageLen, linkobject, success, failure) => {
		Axios.post('/event/searchEventListByUser.do', {
			userId,
			unitId,
			typeNos,
			state,
			level,
			deviceid,
			startTime,
			endTime,
			pageIndex,
			pageLen,
			linkobject
		}, success, failure)
	},
	/**
	 * 通过输入的参数，查看当前筛选结果中，每个事件类型的事件汇总
	 * @param {Object} userId 用户的登录名,不传是当前用户
	 * @param {Object} unitId 单位id
	 * @param {Object} typeNos 事件类型不传是全部,参数用逗号隔开
	 * @param {Object} state 事件状态-1全部0未处理1处理中2已处理3已确认
	 * @param {Object} level 事件等级，不传是默认1,2 (预警，告警)
	 * @param {Object} deviceid 按设备id过滤，支持多个设备id
	 * @param {Object} startTime
	 * @param {Object} endTime
	 * @param {Object} linkobject 关联对象，支持模糊查询
	 */
	countEventListByUser:(userId, unitId, typeNos, state, level, deviceid, startTime, endTime, linkobject, success, failure) => {
		Axios.post('/event/countEventListByUser.do', {
			userId,
			unitId,
			typeNos,
			state,
			level,
			deviceid,
			startTime,
			endTime,
			linkobject
		}, success, failure)
	},
	/**
	 * 通过输入的参数，统计单位指定事件范围各类型事件总数
	 * @param {Object} unitId 单位id
	 * @param {Object} classNo 组no
	 * @param {Object} deviceNo 按设备id过滤
	 * @param {Object} startTime
	 * @param {Object} endTime
	 */
	countEventListByUnit: (unitId, classNo, deviceNo, startTime, endTime, success, failure) => {
		Axios.post('/event/countEventListByUnit.do', {
			unitId,
			classNo,
			deviceNo,
			startTime,
			endTime
		}, success, failure)
	},
	/**
	 * 查询所有事件类型
	 */
	searchAllEventTypes: (success, failure) => {
		Axios.post('/event/searchAllEventTypes.do', {}, success, failure)
	},
	/**
	 * 查询no对应的事件
	 */
	searchEventByEventNos: (eventNos, success, failure) => {
		Axios.post('/event/searchEventByEventNos.do', {
			eventNos
		}, success, failure)
	},
	/**
	 * 确认事件
	 */
	confirmEventByEventNo: (eventNo, success, failure) => {
		Axios.post('/event/confirmEventByEventNo.do', {
			eventNo
		}, success, failure)
	},
	/**
	 * 批量确认事件
	 */
	confirmEventByEventNos: (eventNos, success, failure) => {
		Axios.post('/event/confirmEventByEventNos.do', {
			eventNos
		}, success, failure)
	},
	/**
	 * 通过事件时间和描述查找事件对象
	 */
	getEventByTimeAndDescription: (eventTime, description, success, failure) => {
		Axios.post('/event/getEventByTimeAndDescription.do', {
			eventTime,
			description
		}, success, failure)
	},

	searchEventListByLinkDevice: (linkDevice, pageIndex, pageLen, typeNos, success, failure) => {
		Axios.post('/event/searchEventListByLinkDevice.do', {
			linkDevice,
			pageIndex,
			pageLen,
			typeNos
		}, success, failure)
	},
	/**
	 * 查询uuid对应的事件列表
	 */
	searchEventByUuids: (uuids, success, failure) => {
		Axios.post('/event/searchEventByUuids.do', {
			uuids
		}, success, failure)
	},
	/**
	 * 通过UUID确认事件
	 */
	confirmEventByUuids: (uuids, success, failure) => {
		Axios.post('/event/confirmEventByUuids.do', {
			uuids
		}, success, failure)
	},
	/**
	 * 计算在指定时间段内设备最长的无故障时间（即相邻两个事件的时间差）
	 */
	getFailureFreeTimeByDeviceNo: (deviceNo, beginTime, endTime, level, success, failure) => {
		Axios.post('/event/getFailureFreeTimeByDeviceNo.do', {
			deviceNo,
			beginTime,
			endTime,
			level,
		}, success, failure)
	},
	/**
	 * 获取单位下是否有未告警事件
	 */
	checkUnitEventIsExist: (unitIds, success, failure) => {
		Axios.post('/event/checkUnitEventIsExist.do', {
			unitIds,
		}, success, failure)
	},
	/**
	 * 获取月的总事件数
	 */
	countUnitEventsByMonth: (time,month,unitId,success, failure) => {
		Axios.post('/event/countUnitEventsByMonth.do', {
			time,
			month,
			unitId
		}, success, failure)
	},
	/**
	 * 单位概况事件统计
	 */
	countUnitEvents: (unitId,success, failure) => {
		Axios.post('/event/countUnitEvents.do', {
			unitId
		}, success, failure)
	},
}